import { render, staticRenderFns } from "./RecipeDetail.vue?vue&type=template&id=185f7196&scoped=true"
import script from "./RecipeDetail.vue?vue&type=script&lang=js"
export * from "./RecipeDetail.vue?vue&type=script&lang=js"
import style0 from "./RecipeDetail.vue?vue&type=style&index=0&id=185f7196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185f7196",
  null
  
)

export default component.exports